import Modal from "../../components/Modal/Modal";
import Select from "../../components/Select/SearchableSelect";
import Input from "../../components/Input/Input";
import Button from "../../components/Button/Button";

const ClassTeacherForm = ({
    isModalOpen,
    closeModal,
    formData,
    teacherList,
    handleChange,
    handleSave
}) => {
    return (  
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Class Teacher Mapping"
        size="md"
        footer={
          <>
            <Button variant="secondary" className="mx-2" onClick={closeModal}>
              Cancel
            </Button>

            <Button variant="primary" onClick={handleSave}>
              Save
            </Button>
          </>
        }
      >
        {/* Class Teacher */}

        <div className="mb-3 mt-2">
          <Select
            label={"Class Teacher"}
            name="user_id"
            value={formData.user_id}
            options={teacherList}
            onChangeHandler={handleChange}
          />
        </div>

        {/* Class In Charge */}
        <div className="mb-3">
          <Select
            label={"Class In Charge"}
            name="class_in_charge_id"
            value={formData.class_in_charge_id}
            options={teacherList}
            onChangeHandler={handleChange}
          />
        </div>

        {/* Commencement Date */}
        <div className="mb-3">
          <label>Commencement Date</label>
          <Input
            type="date"
            name="commencement_date"
            value={formData.commencement_date}
            onChange={handleChange}
            className="form-control"
          />
        </div>
      </Modal>);
};

export default ClassTeacherForm;